import { render } from "./Bottom.vue?vue&type=template&id=7c74cf49&scoped=true"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=7c74cf49&lang=less&scoped=true"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c74cf49"]])

export default __exports__